import { ExpandOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ComponentProps, ReactNode, useId } from "react";
import WidgetState from "./WidgetState";

interface DashboardCardProps extends ComponentProps<typeof WidgetState> {
	badge: string;
	title: string;
	/** Grid placement and row classes from dashboard.scss. */
	className: string;
	/** Tenant and period selects. */
	controls?: ReactNode;
	onExpand?: () => void;
	/** Edge-to-edge body, for the map. */
	flush?: boolean;
}

/** Widget chrome: badge, title, controls, expand button, then the body state. */
function DashboardCard({
	badge,
	title,
	className,
	controls,
	onExpand,
	flush = false,
	...state
}: DashboardCardProps) {
	const titleId = useId();

	return (
		<section
			className={`dashboard-card ${className}`}
			aria-labelledby={titleId}
		>
			<div className="dashboard-card__header">
				<div className="dashboard-card__heading">
					{/* A visual module code; the heading already names the widget. */}
					<span className="dashboard-card__badge" aria-hidden="true">
						{badge}
					</span>
					<h2 id={titleId} className="dashboard-card__title" title={title}>
						{title}
					</h2>
				</div>
				<div className="dashboard-card__tail">
					<svg
						className="dashboard-card__notch"
						width="14"
						height="8"
						viewBox="0 0 14 8"
						aria-hidden="true"
						focusable="false"
					>
						<path d="M0 7.25 14 1.5" stroke="currentColor" strokeWidth="1.5" />
					</svg>
					{controls}
					{onExpand && (
						<Button
							type="text"
							className="dashboard-card__expand"
							icon={<ExpandOutlined />}
							aria-label={`Expand ${title}`}
							onClick={onExpand}
						/>
					)}
				</div>
			</div>
			<div
				className={`dashboard-card__body${flush ? " dashboard-card__body--flush" : ""}`}
			>
				<WidgetState {...state} />
			</div>
		</section>
	);
}

export default DashboardCard;
